import * as React from 'react';
const SvgPrint = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18.075 4.933h-1.933v-4.9H3.858v4.9H1.925l-.625.625V15.2l.625.625h1.933v4.133h12.284v-4.133h1.933l.625-.625V5.558zM5.108 1.283h9.784v3.65H5.108zm9.784 17.434H5.108v-7.709h9.784zm2.558-4.142h-1.308V9.75H3.858v4.825H2.55V6.183h14.9z" />
    <path d="M13.867 14.233H6.133v1.25h7.734zM13.867 12.033H6.133v1.25h7.734zM10.117 16.517H6.133v1.25h3.984zM16.108 8.208a.686.686 0 0 0 .684-.683.686.686 0 0 0-.684-.683.686.686 0 0 0-.683.683c0 .375.308.683.683.683" />
  </svg>
);
export default SvgPrint;
